import { NavLinkConfig, NavLinkId } from '../data/types/nav';
import { TxNameCode } from '../data/types/tx';

export enum AppEnv {
  LOCAL = 'local',
  DEV = 'dev',
  STG = 'stg',
  TRN = 'trn',
  BF = 'bf',
  PROD = 'prod',
}

export type EnvProps = {
  appEnv: AppEnv;
  ebisCoreServiceUrl: string;
  ebisReportServiceUrl: string;
  ebisUIUrl: string;
  ebisAdvSearchServiceUrl: string;
  ebisGlobalServiceUrl: string;
  eventBusUrl: string;
  ebisClubServiceUrl: string;
  cepServiceUrl: string;
  loginUrl: string;
  legacyAppBaseUrl: string;
  oauth2: {
    clientId: string;
    issuer: string;
  };
  idleTimeoutMs: number;
  idleWarnBufferMs: number;
  reactMigration: {
    migratedLinks: Partial<Record<NavLinkId, NavLinkConfig>>;
  };
  migratedTx: TxNameCode[];
};

declare global {
  interface Window {
    MLBBest: {
      env: EnvProps;
    };
  }
}

export default window.MLBBest?.env;
